import { j as o, c as n } from "./utils-BdNIfrGQ.js";
const l = {
  100: "bg-skeleton-100",
  200: "bg-skeleton-200",
  300: "bg-skeleton-300",
  400: "bg-skeleton-400"
}, a = ({ className: e, grayVariant: s = 400, ...t }) => /* @__PURE__ */ o.jsx("div", { className: n(e, "animate-pulse", l[s]), ...t });
a.displayName = "Skeleton";
export {
  a as S
};
